<template>
    <div class="header">
        <!-- 服务器标签管理 -->
        <header-tag
            :title="
                $PAGE_API.home.children.barManager.children.index.children
                    .serverLabelManage.title
            "
        ></header-tag>
        <div class="right" v-show="listArr.length < 21">
            <a href="#" @click.prevent="addLabel" class="blue-btn">添加标签</a>
        </div>
    </div>
</template>

<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";

export default {
    name: "serverHeader",
    props: {
        listArr: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    components: {
        HeaderTag
    },
    data() {
        return {};
    },
    methods: {
        async addLabel() {
            let res = await window.$modal.editServerLabel.show();
            if (res) {
                this.$emit("reList");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.header {
    padding-left: 30px;
    // padding-top: 20px;
    text-align: left;
    position: relative;
    z-index: 10;
}
.right {
    float: right;
    padding-right: 20px;
    a {
        margin-left: 6px;
        line-height: normal;
        color: #fff;
    }
}
</style>
